module.exports = __webpack_public_path__ + "img/saint-kitts-and-nevis.7ba1c433.svg";